import React from 'react';

import xtend from 'xtend';

import Pagination from '../components/Pagination';

// Results Per Page
const PER = 50;

export default {
    getDefaultPaginationState: function () {
        return {
            pagination: {
                currentPage: 1
            }
        };
    },

    handlePagination: function (page) {
        this.setState({
            pagination: {
                currentPage: page
            }
        });
    },

    getPaginatedData: function (domain) {

        var paginatedData = [];
        const upperBound = this.state.pagination.currentPage * PER;

        if (this.state.term === '') {
            for (var k = (upperBound - PER); k < upperBound; k++) {
                if (!this.props.data[k]) break;
                paginatedData.push(this.props.data[k]);
            }
        } else {
            paginatedData = this.props.data;
        }

        return paginatedData;
    },

    renderPagination: function () {
        var totalPages = 0;

        if (this.props.data.length && this.state.term === '') {
            totalPages = Math.ceil(this.props.data.length / PER);
        }

        if (totalPages > 0) {
            var paginationProps = xtend(this.state.pagination, {
                disabled: false,
                per: PER,
                totalPages: totalPages
            });

            return (
                <Pagination {...paginationProps} onPageChange={this.handlePagination}/>
            );
        }
        return null;
    }
};